<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0">
        <!-- <b-col> </b-col> -->
        <b-col class="text-right">
          <downloadChart :commitName="'Risk spread'" />
        </b-col>
      </b-row>
      <b-row class="m-0 chartTabPanel autoCursor scroll50Panel">
        <b-col ref="capture">
          <b-row>
            <b-col cols="6" class="col-md-12 col-lg-6 graph-height">
              <b-card>
                <Plotly
                  :data="riskspreadChartData1"
                  :layout="lineBarlayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
            <b-col cols="6" class="col-md-12 col-lg-6 graph-height">
              <b-card>
                <Plotly
                  :data="riskspreadChartData2"
                  :layout="linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="col-md-12 col-lg-6 graph-height">
              <b-card>
                <template #header>
                  <b-row>
                    <b-col><h6 class="mb-0">riskspreadChartData3</h6></b-col>
                  </b-row>
                </template>
                <Plotly
                  :data="riskspreadChartData3Data"
                  :layout="Barlayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
            <b-col cols="6" class="col-12 col-lg-6 graph-height">
              <b-card>
                <template #header>
                  <b-row>
                    <b-col
                      ><h6 class="mb-0">
                        lower_right_chart
                      </h6></b-col
                    >
                  </b-row>
                </template>
                <Plotly
                  :data="riskspreadChartData4Data"
                  :layout="linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
          </b-row> </b-col
      ></b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Risk_spread",
  components: {
    Plotly,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      nominalgdplessfedfund: "nominalgdplessfedfund",
      year10treasuryless3montheuro: "year10treasuryless3montheuro",
      keybankratesfececbetc: "keybankratesfececbetc",
      keybankrateschinabrazil: "keybankrateschinabrazil",
      isFullScreen: "isFullScreen",
      riskspreadChart1: "riskspreadChart1",
      riskspreadChart2: "riskspreadChart2",
      riskspreadChart3: "riskspreadChart3",
      riskspreadChart4: "riskspreadChart4",
    }),
    riskspreadChartData1() {
      let formattedData = this.riskspreadChart1.map(function(i) {
        return {
          lineField: +i.one_neg_std_dev,
          lineField1: +i.one_pos_std_dev_,
          lineField2: +i.spread_10_year,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "+1 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#CC9541",
        },
      };
      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "-1 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#000",
        },
      };
      let trace3 = {
        type: "scatter",
        mode: "lines",
        name: "Spread 10-year less 2-year",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField2"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#666666",
        },
      };
      let data = [trace1, trace2, trace3];
      return data;
    },
    riskspreadChartData2() {
      let formattedData = this.riskspreadChart2.map(function(i) {
        return {
          lineField: +i.neg_075_std,
          lineField1: +i.pos_075_std,
          lineField2: +i["10_year_treasury"],
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "+1 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#CC9541",
        },
      };
      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "-1 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#000",
        },
      };
      let trace3 = {
        type: "scatter",
        mode: "lines",
        name: "Spread 10-year less 2-year",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField2"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#666666",
        },
      };
      let data = [trace1, trace2, trace3];
      return data;
    },
    riskspreadChartData3Data() {
      let formattedData = this.riskspreadChart3.map(function(i) {
        return {
          lineField: +i.neg_075_std_dev,
          lineField1: +i.pos_075_std_dev,
          lineField2: +i.baa_yield,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "-.75 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#CC9541",
        },
      };
      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "+.75 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#000",
        },
      };
      let trace3 = {
        type: "scatter",
        mode: "lines",
        name: "Baa yield",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField2"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#666666",
        },
      };
      let data = [trace1, trace2, trace3];
      return data;
    },
    riskspreadChartData4Data() {
      let formattedData = this.riskspreadChart4.map(function(i) {
        return {
          lineField: +i.neg_2_std_dev,
          lineField1: +i.pos_2_std_dev,
          lineField2: +i.baa_yield_less_10_year,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "+1 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#CC9541",
        },
      };
      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "-2 Std Dev.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#000",
        },
      };
      let trace3 = {
        type: "scatter",
        mode: "lines",
        name: "Baa yield less 10-year Treasury yield",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField2"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#666666",
        },
      };
      let data = [trace1, trace2, trace3];
      return data;
    },
  },
  data() {
    return {
      chartTitle: "",

      linelayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 100,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },

        legend: {
          x: 0,
          y: -0.5,
          orientation: "h",
        },
      },
      lineBarlayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },

        legend: {
          x: 0,
          y: -0.5,
          orientation: "h",
        },
      },
      Barlayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },

        legend: {
          x: 0,
          y: -0.8,
          orientation: "h",
        },
      },
      config: { responsive: true },
      sliderValue: [2018, 2021],
      min: 2018,
      max: 2021,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      riskspreadChart1Clone: [],
      riskspreadChart2Clone: [],
      riskspreadChart3Clone: [],
      riskspreadChart4Clone: [],
    };
  },
  created() {
    // console.log('this.$refs.capture-=-=-',this.$refs);
    this.setDownloadInfo({
      fileName: "Risk_spread",
      downloadData: this.$refs.capture,
    });
  },
  watch: {
    riskspreadChart1: {
      deep: true,
      handler() {
        // console.log("riskspreadChart1", this.riskspreadChart1);
        if (this.riskspreadChart1 && this.riskspreadChart1.length) {
          this.riskspreadChart1Clone = this.riskspreadChart1;
        }
      },
    },
    riskspreadChart2: {
      deep: true,
      handler() {
        // console.log("riskspreadChart2", this.riskspreadChart2);
        if (this.riskspreadChart2 && this.riskspreadChart2.length) {
          this.riskspreadChart2Clone = this.riskspreadChart2;
        }
      },
    },
    riskspreadChart3: {
      deep: true,
      handler() {
        // console.log("riskspreadChart3", this.riskspreadChart3);
        if (this.riskspreadChart3 && this.riskspreadChart3.length) {
          this.riskspreadChart3Clone = this.riskspreadChart3;
        }
      },
    },
    riskspreadChart4: {
      deep: true,
      handler() {
        // console.log("riskspreadChart4", this.riskspreadChart4);
        if (this.riskspreadChart4 && this.riskspreadChart4.length) {
          this.riskspreadChart4Clone = this.riskspreadChart4;
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "getIframeChartDataById",
    ]),
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    slideChange(e) {
      var chartData = this.waterfallsales;
      let filterData = { x: [], y: [], measure: [], text: [] };
      for (let i = 0; i < chartData[0].x.length; i++) {
        if (
          parseInt(chartData[0].x[i].split(" ")[1]) >= parseInt(e[0]) &&
          parseInt(chartData[0].x[i].split(" ")[1]) <= parseInt(e[1])
        ) {
          filterData.x.push(chartData[0].x[i]);
          filterData.y.push(chartData[0].y[i]);
          filterData.measure.push(chartData[0].measure[i]);
          filterData.text.push(chartData[0].text[i]);
        }
      }
      this.waterfallData[0].x = filterData.x;
      this.waterfallData[0].y = filterData.y;
      this.waterfallData[0].measure = filterData.measure;
      this.waterfallData[0].text = filterData.text;
      this.waterfallData.upperRange = e[1];
      this.waterfallData.lowerRange = e[0];
    },
    async chartData() {
      let chart_API_Data = [];
      if (window.location.href.includes("auth_token=")) {
        let data = await this.getIframeChartDataById(75);
        this.cpiandsentimentsClone = data;
      } else {
        this.cpiandsentimentsClone = this.cpiandsentiments;
      }
      this.cpiandsentimentsHandler(chart_API_Data);
    },
  },
  mounted() {
    this.setDownloadInfo({
      fileName: "GDP_Treasury_yield",
      downloadData: this.$refs.capture,
    });
    if (window.location.href.includes("auth_token=")) {
      this.chartData();
    }
  },
};
</script>

<style lang="scss">
.graph-height {
  margin-bottom: 20px;
}
.salesContainer {
  position: relative;
}
.card-header .slider.slider-horizontal {
  width: 100% !important;
  height: 20px;
}
.scroll50Panel {
  height: 45vh;
  padding-bottom: 50px;
  overflow: auto;
}
.svg-container,
.js-plotly-plot .plotly .main-svg {
  width: 100% !important;
  max-width: 100% !important;
}
</style>
